<template>
  <div>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      max-width="1000px"
      persistent
      scrollable
    >
      <v-card title="Selecione o Par Biomagnético">
        <v-card-title>
          <card-title-with-back-button
            title="Selecione o Par Biomagnético"
            @back="close"
          />
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="(ip, index) in aggrergationPairs"
              :key="index"
              class="border-bottom-grey pa-3"
              @click="selectPar(ip)"
            >
              <v-list-item-content>
                <div class="d-flex">
                  <tooltip-icon
                    v-if="isParAlreadyAddedToDiagnosis(ip)"
                    color="primary"
                    icon="radio_button_checked"
                    text="Par já adicionado ao diagnóstico"
                    class="mr-2"
                  />
                  <tooltip-icon
                    v-else
                    color="grey"
                    icon="radio_button_unchecked"
                    text="Par não adicionado ao diagnóstico"
                    class="mr-2"
                  />
                  <span class="body-1">
                    <span class="pl-1">{{ index + 1 }}</span>
                    <span class="pr-2 pl-2">-</span>
                    {{ ip.name }}
                  </span>
                </div>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon>open_in_new</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            large
            class="mt-3"
            outlined
            color="black"
            width="100%"
            @click="close"
          >
            <v-icon>arrow_back</v-icon>
            Voltar ao rastreio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    dialog: {
      get() {
        return this.$store.state.dialogs.pares.aggrergationPairs;
      },
      set(value) {
        this.$store.commit("dialogs/setAggrergationPairs", value);
      },
    },
    aggrergationPairs() {
      return this.$store.getters["points/selectedAggregationPairs"];
    },
    selectedAggregation() {
      return this.$store.getters["points/selectedAggregation"];
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    async selectPar(pair) {
      await this.$store.dispatch("pares/selectAggregationPair", pair);
    },
    isParAlreadyAddedToDiagnosis({ id }) {
      console.log(id, this.$store.getters["diagnosis/addedPares"]);
      return this.$store.getters["diagnosis/addedPares"].some(
        (diagnosePar) => diagnosePar.par.id === id
      );
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0 !important;
}
</style>
